export enum TabPanelEnum {
  PROPERTIES = 0,
  CERTIFICATIONS = 1,
  IOT_DEVICE = 2,
  NUTRIENTS = 3,
}
